module.exports = __webpack_public_path__ + "static/media/power-icon.b711b109.svg";